import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="language-switcher"
      aria-label="Switch language"
    >
      <Globe size={18} />
      <span className="language-code">{language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitcher;
